import frLocale from 'element-ui/lib/locale/lang/fr'
import home from './fr/home'

const fr = {
    language: 'français',
    message: {
        'home': {
            ...home,
            enterEmail: 'Veuillez saisir l\'e-mail',
            save: 'Enregistrer',
            saveSuccess: 'Enregistré avec succès',
            pointHistory: 'Historique des points',
            type: 'Type',
            remark: 'Remarque',
            pendingComment: 'À évaluer',
            commented: 'Évalué',
            selectDate: 'Sélectionner une date',
            loginSuccess: 'Connexion réussie',
            loginFail: 'Échec de la connexion',
            close: 'Fermer',
            required: 'Obligatoire',
            nickname: 'Pseudo',
            enterNickname: 'Veuillez saisir un pseudo',
            gender: 'Sexe',
            male: 'Homme',
            female: 'Femme',
            secret: 'Confidentiel',
            birthday: 'Anniversaire',
            checkoutLoadFailed: 'Échec du chargement des informations de paiement. Veuillez réessayer plus tard.',
            checkoutErrorTitle: 'Information',
            goAddAddress: 'Ajouter une adresse de livraison',
            shop_order_selectOrAddAddress: 'Veuillez d\'abord ajouter une adresse de livraison et la définir par défaut avant de passer commande.',
            shop_order_cartEmpty: 'Le panier est vide, impossible de passer commande.',
            shop_order_cartHasNotActive: 'Certains articles ne sont pas en vente ou invalides, impossible de passer commande.',
            shop_order_cartHasNotMarketable: 'Certains articles ne sont plus disponibles, impossible de passer commande.',
            shop_order_cartHasLowStock: 'Stock insuffisant, impossible de passer commande.',
            shop_order_cartHasExpiredGoods: 'Certains articles de la boutique ont expiré, impossible de passer commande.',
            shop_order_typeIsNull: 'Type de commande non reconnu, veuillez vérifier le type d\'article.',
            shop_order_goodsNotFound: 'Les informations du produit n\'existent pas ou ont été supprimées.',
            shop_order_giftNotForSale: 'Les articles cadeaux ne peuvent pas être achetés directement.',
            common_message_badRequest: 'Requête invalide, veuillez vérifier le produit et les paramètres.',
        },
    },
    '手机号码最小长度为8位': 'La longueur minimale du numéro de téléphone mobile est de 8 chiffres',
    '邮箱账号名称最小长度为6位': 'La longueur minimale du nom du compte de messagerie est de 6 caractères',
    '邮箱只能包含英文，数字等字符': "La boîte aux lettres ne peut contenir que des caractères tels que l'anglais et des chiffres",
    '请选择正确的收货地址': 'Veuillez sélectionner la bonne adresse de livraison',
    Dict_language_status_0: 'Désactivé',
    Dict_language_status_1: 'Activé',
    Dict_member_label_type_1: 'Étiquette conditionnelle',
    Dict_member_label_type_2: 'Étiquette manuelle',
    Dict_member_level_type_0: 'Niveau de consommation (LV)',
    Dict_member_level_type_1: 'Membre payant (VIP)',
    Dict_member_growth_action_type_1: 'Passer une commande',
    Dict_member_growth_action_type_2: 'Connexion quotidienne',
    Dict_member_growth_action_type_3: 'Publier un avis',
    Dict_member_growth_action_type_4: 'Compléter le profil',
    Dict_paid_member_payment_type_0: 'Paiement par solde',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Valide',
    Dict_paid_member_record_status_1: 'Expiré',
    Dict_paid_member_record_status_2: 'Remboursé',
    Dict_point_lottery_prize_type_0: 'Points',
    Dict_point_lottery_prize_type_1: 'Coupon',
    Dict_point_lottery_prize_type_2: 'Prix physique',
    Dict_point_lottery_prize_type_3: 'Merci de votre participation',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'E-mail',
    Dict_notification_channel_type_2: 'Message interne',
    Dict_notification_channel_type_3: 'Notification push',
    Dict_announcement_status_0: 'Brouillon',
    Dict_announcement_status_1: 'Publié',
    Dict_announcement_status_2: 'Retiré',
    Dict_live_permission_status_0: 'Non demandé',
    Dict_live_permission_status_1: 'En cours de révision',
    Dict_live_permission_status_2: 'Activé',
    Dict_live_permission_status_3: 'Rejeté',
    Dict_live_room_status_0: 'Non commencé',
    Dict_live_room_status_1: 'En direct',
    Dict_live_room_status_2: 'Terminé',
    Dict_live_room_status_3: 'Interruption anormale',
    Dict_live_room_type_0: 'Direct plateforme',
    Dict_live_room_type_1: 'Direct marchand',
    Dict_store_type_0: 'Boutique individuelle',
    Dict_store_type_1: 'Boutique entreprise',
    Dict_store_sign_status_0: 'À signer',
    Dict_store_sign_status_1: 'Signé',
    Dict_store_sign_status_2: 'Résilié',
    Dict_store_business_change_status_0: 'À examiner',
    Dict_store_business_change_status_1: 'Approuvé',
    Dict_store_business_change_status_2: 'Rejeté',
    Dict_decoration_page_type_0: 'Page d\'accueil',
    Dict_decoration_page_type_1: 'Page de catégorie',
    Dict_decoration_page_type_2: 'Page de campagne',
    Dict_decoration_page_type_3: 'Page personnalisée',
    Dict_decoration_status_0: 'Brouillon',
    Dict_decoration_status_1: 'Publié',
    Dict_decoration_popup_trigger_page_0: 'Accueil de la plateforme',
    Dict_decoration_popup_trigger_page_1: 'Espace membre',
    Dict_decoration_popup_trigger_page_2: 'Paiement réussi',
    Dict_decoration_popup_target_user_0: 'Tous les utilisateurs',
    Dict_decoration_popup_target_user_1: 'Membres gratuits',
    Dict_decoration_popup_target_user_2: 'Membres payants',
    Dict_decoration_popup_frequency_0: 'Une fois définitivement',
    Dict_decoration_popup_frequency_1: 'À chaque visite',
    Dict_decoration_popup_frequency_2: 'Fréquence personnalisée',
    Dict_track_event_type_page_view: 'Vue de page',
    Dict_track_event_type_click: 'Clic',
    Dict_track_event_type_add_to_cart: 'Ajouter au panier',
    Dict_track_event_type_search: 'Recherche',
    Dict_track_event_type_purchase: 'Achat',
    Dict_track_event_type_live_watch: 'Regarder le direct',
    Dict_reconcile_period_type_0: 'Quotidien',
    Dict_reconcile_period_type_1: 'Hebdomadaire',
    Dict_reconcile_period_type_2: 'Mensuel',
    Dict_store_settlement_status_0: 'En attente de règlement',
    Dict_store_settlement_status_1: 'Réglé',
    Dict_distributor_status_0: 'À examiner',
    Dict_distributor_status_1: 'Examiné',
    Dict_distributor_status_2: 'Rejeté',
    Dict_distribution_commission_type_0: 'Commission directe',
    Dict_distribution_commission_type_1: 'Commission indirecte',
    Dict_configuration_status_0: 'Désactivé',
    Dict_configuration_status_1: 'Activé',
    ...frLocale
}
export default fr
